import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_SETTINGS } from '@/lib/constants/api'
import getSettingsModel from './models/settings'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const settings = {
  namespaced: true,
  state: {
    ...getSettingsModel()
  },
  getters: {
    getField,
    getAssignmentObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearSettings: (state) => {
      state.dashboardSettings = {}
      state.newDealNotificationRecipients = []
      state.approvedDealNotificationRecipients = []
      state.rejectedDealNotificationRecipients = []
      state.carbonCopyDealNotificationRecipients = []
      state.headCountSettings = {}
      state.payRateSettings = {}
      state.zohoIntegrationSettings = {}
      state.beginningOfWeek = null
      state.scheduledJobsSettings = {}
      state.emailSettings = {}
    },
    setSettings: (state, settings) => {
      state.dashboardSettings = settings.dashboardSettings
      state.newDealNotificationRecipients = settings.newDealNotificationRecipients || []
      state.approvedDealNotificationRecipients = settings.approvedDealNotificationRecipients || []
      state.rejectedDealNotificationRecipients = settings.rejectedDealNotificationRecipients || []
      state.carbonCopyDealNotificationRecipients = settings.carbonCopyDealNotificationRecipients || []
      state.headCountSettings = settings.headCountSettings
      state.payRateSettings = settings.payRateSettings
      state.zohoIntegrationSettings = settings.zohoIntegrationSettings
      state.beginningOfWeek = settings.beginningOfWeek
      state.scheduledJobsSettings = settings.scheduledJobsSettings
      state.emailSettings = settings.emailSettings
    }
  },
  actions: {
    getSettings: ({ commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting settings data, please wait...' })

      return api.doGet({ path: PATH_SETTINGS, parameters: {} })
        .then(json => json.data)
        .then(settings => {
          commit('updateStatus', { status: COMPLETE })
          commit('setSettings', settings)
          hideProgressModal({ dispatch })

          return settings
        }).catch((error) => {
          hideProgressModal({ dispatch })
          commit('updateStatus', { status: ERROR, error })
        })
    },
    updateSettings: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Updating settings, please wait...' })

      return api.doPut({ path: PATH_SETTINGS, data: state }).then(response => {
        commit('updateStatus', { status: COMPLETE })

        if (!response.data) {
          throw new Error('Unable to update settings. Try again later.')
        }

        hideProgressModal({ dispatch })
        notifySuccess(dispatch, 'Settings updated')
        return response.data
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        hideProgressModal({ dispatch })
        notifyError(dispatch, 'Unable to update settings. Try again later')

        throw error
      })
    }
  }
}

export default settings
